import { ComplianceSection } from './ComplianceSection';
const meta = {
    title: 'Features/AIChatWidget/ComplianceSection',
    component: ComplianceSection
};
export default meta;
export const Default = {};
/** The technician host: "How to use IP Assistant" sits beside Terms of Service and stays visible on narrow iPads. */
export const WithHowToLink = {
    args: { onHowToUse: () => undefined }
};
/** Disabled while the input is, so a tap cannot send over a streaming reply. */
export const HowToLinkDisabled = {
    args: { onHowToUse: () => undefined, isHowToUseDisabled: true }
};
